var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8802 15.3543C11.1093 13.4315 11.0259 11.3016 11.6442 9.32442C12.2625 7.34728 13.5445 5.64425 15.2734 4.5032C17.0024 3.36214 19.0723 2.85305 21.1333 3.06198C23.1943 3.2709 25.12 4.18503 26.5848 5.64985C28.0496 7.11466 28.9637 9.04032 29.1726 11.1013C29.3816 13.1623 28.8725 15.2322 27.7314 16.9612C26.5904 18.6902 24.8873 19.9721 22.9102 20.5904C20.933 21.2087 18.8031 21.1253 16.8803 20.3545L16.8803 20.3543L15.2344 22.0002H12.2344V25.0002H9.23438V28.0002H4.23438V23.0002L11.8804 15.3542L11.8802 15.3543Z",
    stroke: "#EE7A30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.7344 10C23.0105 10 23.2344 9.77614 23.2344 9.5C23.2344 9.22386 23.0105 9 22.7344 9C22.4582 9 22.2344 9.22386 22.2344 9.5C22.2344 9.77614 22.4582 10 22.7344 10Z",
    fill: "#EE7A30",
    stroke: "#EE7A30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7344 11C23.5628 11 24.2344 10.3284 24.2344 9.5C24.2344 8.67157 23.5628 8 22.7344 8C21.9059 8 21.2344 8.67157 21.2344 9.5C21.2344 10.3284 21.9059 11 22.7344 11Z",
    fill: "#EE7A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.63f20e22db675e6a807c97f6e05b3fb6.svg";
export { ForwardRef as ReactComponent };